import { TypedDocumentNode, gql } from "apollo-angular";

import {
  IpPrefixesListQueryQuery,
  IpPrefixesListQueryQueryVariables,
} from "../../apis/networkdashboard/graphql/graphql";

export const IP_PREFIXES_LIST_QUERY: TypedDocumentNode<IpPrefixesListQueryQuery, IpPrefixesListQueryQueryVariables> =
  gql`
    query IpPrefixesListQuery($customer: UUID!) {
      ipPrefixList(sort: { subscriptionId: ASC }, searchFilter: { accessCustomerId: $customer, status: ACTIVE }) {
        page {
          subscriptionType: __typename
          subscriptionId
          customerId
          description
          startDate
          customerDescription
          insync

          ipPrefix {
            afi
            state
            prefix
          }

          ipSubscriptions {
            subscriptionId
            customerId
            description
            customerDescription
            product {
              type
              tag
            }
          }

          availableIpSubscriptions {
            subscriptionId
            customerId
            description
            customerDescription
            product {
              type
              tag
            }
          }
        }
      }
    }
  `;
